import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SearchExperience from "@/components/SearchExperience";
import SEOHead from "@/components/SEOHead";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd, courseSlug, titleCase } from "@/lib/seo";

export default function CoursePage() {
  const { slug } = useParams();
  const [course, setCourse] = useState(null); // resolved real Course_Name
  const [matched, setMatched] = useState(true);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    api.get("/courses").then((r) => {
      const match = (r.data.courses || []).find((c) => courseSlug(c.name) === slug);
      setMatched(!!match);
      setCourse(match ? match.name : titleCase(slug));
    }).catch(() => { setMatched(false); setCourse(titleCase(slug)); }).finally(() => setReady(true));
  }, [slug]);

  if (!ready) return null;

  const path = `/course/${slug}`;
  const crumbs = [{ name: "Home", path: "/" }, { name: `${course} Colleges`, path }];

  return (
    <>
      <SEOHead
        title={`${course} Colleges — Admissions & Fees`}
        description={`Find colleges offering ${course}. Compare courses, fees and placements, and get free admission guidance.`}
        canonicalPath={path}
        noindex={!matched}
        jsonLd={[breadcrumbLd(crumbs)]}
      />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <Breadcrumbs items={crumbs} />
      </div>
      <SearchExperience
        key={slug}
        lockedFilters={{ course }}
        title={`${course} Colleges`}
        subtitle={`Institutions offering ${course} programmes.`}
      />
    </>
  );
}
